<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      d="M13.0039 3C8.03391 3 4.00391 7.03 4.00391 12H1.00391L4.89391 15.89L4.96391 16.03L9.00391 12H6.00391C6.00391 8.13 9.13391 5 13.0039 5C16.8739 5 20.0039 8.13 20.0039 12C20.0039 15.87 16.8739 19 13.0039 19C11.0739 19 9.32391 18.21 8.06391 16.94L6.64391 18.36C8.27391 19.99 10.5139 21 13.0039 21C17.9739 21 22.0039 16.97 22.0039 12C22.0039 7.03 17.9739 3 13.0039 3ZM12.0039 8V13L16.2839 15.54L17.0039 14.33L13.5039 12.25V8H12.0039Z"
      fill="#F2C94C"
    />
  </svg>
</template>
